import { FC, ReactNode } from 'react';
import { Typography } from '@mui/material';
import {
  PAID_MESSAGE,
  DR_PAID_IN_FULL_MESSAGE,
  DR_PAID_SETTLEMENT_MESSAGE,
  WITH_DR_MESSAGE,
  DR_CANCELLED_MESSAGE,
} from '../constants/constants';
import {
  BREACH_STATUS,
  BreachStatusValue,
} from '../../models/breach-details.interface';

interface Props {
  statusValue: BreachStatusValue;
}

const BreachStatusMessage: FC<Props> = ({ statusValue }) => {
  const renderBaycorpMessage = (prefix: string) => (
    <Typography variant="body1">
      {prefix} For further enquiries, or for further assistance, please contact
      Baycorp on <strong>0800 081 576</strong> or{' '}
      <a href="mailto:customercare@baycorp.co.nz">customercare@baycorp.co.nz</a>
      .
    </Typography>
  );

  const statusMessages: Record<BreachStatusValue, ReactNode> = {
    [BREACH_STATUS.PAID]: (
      <Typography variant="body1">{PAID_MESSAGE}</Typography>
    ),
    [BREACH_STATUS.DR_PAID_IN_FULL]: (
      <Typography variant="body1">{DR_PAID_IN_FULL_MESSAGE}</Typography>
    ),
    [BREACH_STATUS.DR_PAID_SETTLEMENT]: (
      <Typography variant="body1">{DR_PAID_SETTLEMENT_MESSAGE}</Typography>
    ),
    [BREACH_STATUS.WITH_DR]: renderBaycorpMessage(WITH_DR_MESSAGE),
    [BREACH_STATUS.DR_CANCELLED]: renderBaycorpMessage(DR_CANCELLED_MESSAGE),
  };

  const message = statusMessages[statusValue];
  if (!message) return null;

  return <>{message}</>;
};

export default BreachStatusMessage;
